



















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Card } from '@/types/Card'
import HomeModule from '@/store/home'
import DealGrid from '@/components/deal/DealGrid.vue'

@Component({
  components: {
    DealGrid
  }
})
export default class HomeDeals extends Vue {
  private get loading(): boolean {
    return HomeModule.isLoading
  }
  private get card(): Card {
    return HomeModule.card!
  }

  private async created(): Promise<void> {
    await HomeModule.setCardById(this.$route.params.cardId)
  }

  private get cardId() {
    return this.$route.params.cardId
  }

  @Watch('cardId')
  private async reloadData(newCardId: string) {
    await HomeModule.setCardById(newCardId)
  }
}
